import { useEffect } from "react";

const FONT_ID = "pingflo-teko-font";

export function usePingfloScoreboardFont() {
  useEffect(() => {
    if (document.getElementById(FONT_ID)) return undefined;
    const link = document.createElement("link");
    link.id = FONT_ID;
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Teko:wght@500;600&display=swap";
    document.head.appendChild(link);
    return undefined;
  }, []);
}

export function formatMatchDay(iso, locale) {
  const date = iso ? new Date(`${String(iso).slice(0, 10)}T12:00:00`) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(locale || undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
  }).format(date);
}

export function formatIssueRange(start, end, locale) {
  const fmt = new Intl.DateTimeFormat(locale || undefined, {
    day: "numeric",
    month: "short",
  });
  const startDate = start ? new Date(`${start}T12:00:00`) : null;
  const endDate = end ? new Date(`${end}T12:00:00`) : null;
  if (!startDate || Number.isNaN(startDate.getTime())) return "";
  if (!endDate || Number.isNaN(endDate.getTime())) return fmt.format(startDate);
  return `${fmt.format(startDate)} — ${fmt.format(endDate)}`;
}
